export function SuccessIcon() {
  return (
    <svg
      className="success-icon"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M60.8674 16.9813L35 42.8487L21.5136 29.3623M55.6718 9.90649C50.034 5.26364 42.8487 2.5 35 2.5C17.0919 2.5 2.5 17.0918 2.5 35C2.5 52.9082 17.0919 67.5 35 67.5C52.9082 67.5 67.5 52.9082 67.5 35C67.5 30.9099 66.7262 27.0408 65.3997 23.3929"
        stroke="currentColor"
        strokeWidth="5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
